import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';
import {COLORS} from 'config/constants';
import {numberWithSpaces} from 'utils/helpers';
import {formatReferenceCopy as formatDemoCopy} from 'utils/typography';
import CustomsDeclaration from './components/customs_declaration';
import CustomsProperty from './components/customs_declaration/components/add_form/property';

import './customs-details.scss';

const CustomsDetails = ({declaration, index, setCodeVatInvalid, onGoalDraftChange, refetchSummary, refetchDeclaration}: CustomsDetailsProps) => {
  const {t} = useTranslation();

  const onSave = () => {
    refetchDeclaration();
    refetchSummary();
  };

  return <div className='customs-details'>
    {declaration.codes.map((code, codeIndex) => <CustomsDeclaration
      key={`${code.code}-${code.country_data.code}`}
      isCompleted={declaration.is_completed}
      declaration={code}
      index={codeIndex}
      onSave={onSave}
      setCodeVatInvalid={setCodeVatInvalid}
      onGoalDraftChange={onGoalDraftChange}
      invoiceId={declaration.invoice_id}
    />)}

    <div className='customs-details__totals'>
      <Typography variant='subtitle1' sx={{fontWeight: 500, color: COLORS.BLACK_DARK, lineHeight: '24px', letterSpacing: 0}}>
        {formatDemoCopy(t('calc__text__customs__preliminaryTitle', {number: index + 1}))}
      </Typography>
      <div className='customs-details__properties'>
        <CustomsProperty label={t('common__text__codesOfHS')} value={declaration.code_count} />
        <CustomsProperty label={t('calc__text__packaging__totalProducts')} value={declaration.product_count} />
        <CustomsProperty label={t('calc__text__customs__totalCustomsTax')} value={`${numberWithSpaces(declaration.tax_total)} USD`} />
        <CustomsProperty label={t('calc__text__customs__totalCustomsPayment')} value={`${numberWithSpaces(declaration.fees_total)} USD`} />
        {Boolean(declaration.utilization_total) && <CustomsProperty label={t('calc__text__customs__utilizationFee')} value={`${numberWithSpaces(declaration.utilization_total)} USD`} />}
        {Boolean(declaration.environmental_total) && <CustomsProperty label={t('calc__text__customs__environmentalFee')} value={`${numberWithSpaces(declaration.environmental_total)} USD`} />}
      </div>
    </div>
  </div>;
};

export default CustomsDetails;
